import React from 'react';
import ReactDOM from 'react-dom';
import 'index.scss';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
//! import the BrowserRouter and assign an alias
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <App />
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
